'use client';

import { Progress } from '@kit/ui/progress';

interface FormProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

/**
 * Visual step indicator for multi-step forms.
 * Displays the current step out of total steps with a progress bar.
 */
export function FormProgressBar({
  currentStep,
  totalSteps,
}: FormProgressBarProps) {
  const progressValue = (currentStep / totalSteps) * 100;

  return (
    <div className="flex flex-col gap-2">
      <div className="text-muted-foreground flex justify-between text-sm">
        <span>
          Step {currentStep} of {totalSteps}
        </span>
        <span>{Math.round(progressValue)}%</span>
      </div>

      <Progress value={progressValue} />
    </div>
  );
}
